import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import RichTextEditorField from 'components/forms/richTextEditor/RichTextEditorField';
import TextField from 'components/forms/textField/TextField';
import { SendOwnerInviteModalFieldsetStyled } from './SendOwnerInviteModal.styles';

const SendOwnerInviteModalFormElements = () => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();

  return (
    <SendOwnerInviteModalFieldsetStyled disabled={isSubmitting}>
      <TextField
        colSmInput={10}
        colSmLabel={2}
        disabled
        label={t('common.to')}
        name="to"
        type="email"
      />

      <TextField
        colSmInput={10}
        colSmLabel={2}
        disabled
        label={t('common.subject')}
        name="subject"
        type="text"
      />

      <RichTextEditorField colSmInput={12} colSmLabel={0} name="content" />

      <CheckboxField name="sendCopyToAgency">
        {t('pageProperty.owners.inviteModal.sendCopyToAgency')}
      </CheckboxField>
    </SendOwnerInviteModalFieldsetStyled>
  );
};

export default SendOwnerInviteModalFormElements;
